import { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import { useSnackbar } from "notistack";
import { Paper, Button, Box, Grid } from '@mui/material';
import { LeasesMenuList, LeasesNav } from '../../../elements';
import { InsuranceCRU, InsuranceList, insuranceObj } from '../components';
import { globalGetService, globalDeleteService } from '../../../../utils/globalApiServices';
import { checkApiStatus } from '../../../../utils';
import { PageLoader, STableLoader } from '../../../../shared_elements';
import { ShowAttachments, DeletePopUp, ButtonLoader, } from '../../../../shared_elements/components';
import { RoleBaseAccess } from '../../../../hoc';
import LeasesBasicDetails from '../../../elements/LeasesBasicDetails';
import { getInsuranceClaimApi, deleteInsuranceApi } from '../apiService';
import VariabilityCRU from '../components/VariabilityCRU';
import { PermissionWrapper } from '../../../../wrappers';
import { trackActivity } from '../../../../utils/mixpanel';
import RevisionHistory from '../../../../shared_elements/components/RevisionHistory';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { isMobile } from 'react-device-detect';
import { useDispatch, useSelector } from 'react-redux';
import { getStorage } from '../../../../shared_elements/actionCreators';
import fileUpload, { getApiResponse } from '../../../../utils/fileUpload';
import FileUploadLayout from '../../../../shared_elements/components/FileUploadLayout';
import ModuleWiseRevisionHistory from '../../../../shared_elements/components/ModuleWiseRevisionHistory';
import InsuranceClaimCardRU from '../components/InsuranceClaimCardRU';
import CustomTabs from '../../../../shared_elements/components/CustomTabs';
import BackToLeaseList from '../../../elements/BackToLeaseList';
import InfoIcon from "@mui/icons-material/Info";
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';

const InsuranceClaim = () => {
    const dispatch = useDispatch()
    const { leaseSlug } = useParams();
    const params = { leaseSlug: leaseSlug }
    const { fileUploadDetails } = useSelector((state) => state.leases);
    const { enqueueSnackbar } = useSnackbar()
    const [isLoading, setLoading] = useState(false)
    const [skeletonLoader, setSkeletonLoader] = useState(false)
    const [insuranceInfo, setInsuranceInfo] = useState({ list: [], pagination: {}, })
    const [insuranceCRU, setInsuranceCRU] = useState({ modal: false, data: null, mode: '' })
    const [deleteInsurance, setDeleteInsurance] = useState({ modal: false, data: null })
    const [attachments, setAttachments] = useState({ modal: false, data: null, type: '', mode: '' })
    const [revisionHistory, setRevisionHistory] = useState({ mode: '', modal: false, data: null });
    const [variabilityCRU, setVariabilityCRU] = useState({ modal: false, data: null, mode: '' })
    const [isExport, seIsExport] = useState(false)
    const [uploadFileProgressData, setUploadFileProgressData] = useState({})
    const [uploadFileStatus, setUploadFileStatus] = useState({ mode: '', modal: false, data: null });
    const [slug, setSlug] = useState({})
    const [tabIndex, setTabIndex] = useState(0);

    useEffect(() => {
        const uploadedFileData = getApiResponse("insurance" || "insurance_claim", slug);
        getInsuranceClaimList('skeletonLoader');
        trackActivity('Page Viewed', { page_title: 'Insurance & Claim' })
        setUploadFileProgressData({ uploadedFileData });
    }, [])

    const getInsuranceClaimList = (loaderType, query = {}) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true);
        globalGetService(getInsuranceClaimApi(params, query))
            .then(response => {
                if (checkApiStatus(response)) {
                    setInsuranceInfo(response.data.data);
                    loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
                }
            })
        dispatch(getStorage({ lease_slug: params?.leaseSlug, module_name: "insurance" }))
    }
    const deleteInsuranceFn = () => {
        setLoading(true);
        globalDeleteService(deleteInsuranceApi(params), { ids: [deleteInsurance?.data?.id] })
            .then(response => {
                if (checkApiStatus(response)) {
                    trackActivity('Item Deleted', { page_title: `Delete Insurance`, success_msg: response?.data?.message, item_id: deleteInsurance?.data, response: response?.data })
                    setLoading(false);
                    setDeleteInsurance({ modal: false, data: null });
                    getInsuranceClaimList('pageloader');
                    enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                } else {
                    setLoading(false);
                    enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                    trackActivity('Item Deleted', { page_title: `Delete Insurance`, error_msg: response?.data?.message, item_id: deleteInsurance?.data, response: response?.data })
                }
            })
    }


    const onDeteAttchments = (deltedslug) => {
        setAttachments({
            ...attachments, data: {
                ...attachments.data,
                attachments: attachments.data.attachments.filter(item => item.slug !== deltedslug)
            }
        });
        if (insuranceCRU?.modal) {
            setInsuranceCRU({
                ...insuranceCRU,
                data: {
                    ...insuranceCRU.data,
                    attachments: insuranceCRU.data.attachments.filter(item => item?.slug !== deltedslug)
                }
            })
        }
        getInsuranceClaimList('');
    }

    const handleUpload = async (slug, mode) => {
        setSlug({ slug: slug })
        await fileUpload({
            attachments: fileUploadDetails.attachments,
            module_name: "insurance",
            slug: slug,
            query: { record_action_type: mode },
            onStart: () => setLoading(true),
            onComplete: () => setLoading(false),
            onProgress: ({ progressRefs, attachments, response }) => {
                setUploadFileProgressData({ progressRefs, attachments, response });
            },
            onSuccess: (success_msg) => {
                enqueueSnackbar(success_msg, {
                    variant: "success",
                    anchorOrigin: { vertical: "top", horizontal: "right" }
                });
                getInsuranceClaimList("", { per_page: 20 });
            },
            onError: (err) => {
                enqueueSnackbar(`${err?.message}` || "Error while uploading files", {
                    variant: "error",
                    anchorOrigin: { vertical: "top", horizontal: "right" }
                });
            }
        });
        setSlug({})
    };

    const handleExport = () => {
        seIsExport(true);
        globalGetService(getInsuranceClaimApi(params, { export: true })).then((response) => {
            if (checkApiStatus(response)) {
                enqueueSnackbar(
                    response?.data.message,
                    { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } }
                );
                seIsExport(false);
            }
        })
    }
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Insurance and Claim`, page_type: page_type, })
    }

    return (
        <>
            <LeasesBasicDetails />
            <Paper className='lease-details-section section-overflow lease-module-paper' elevation={0}>
                <LeasesNav type="technical"/>
                <div className='lease-details-content contnet-overflow'>
                    <Paper square className="responsive-paper">
                        <Grid container className="responsive-grid" alignItems='end'>
                            <Grid item size={{ md: 12, xs: 12 }} className="menu-container">
                                <LeasesMenuList btnText="Insurance & Claim" type="technical"/>
                            </Grid>
                             <Grid item size={{ md: 8, xs: 12 }} className="menu-container">
                                <BackToLeaseList />
                            </Grid>
                            <Grid item size={{ md: 4, xs: 12 }}>
                                <ul className='list-inline lease-details-right-items lease-details-btn' style={{ padding: '0px', float: 'right',minHeight:'35px' }}>
                                    <li className='lease-mobile-button revision-history'><ModuleWiseRevisionHistory ViewGlobalHistory={() => setRevisionHistory({ modal: true, mode: '', data: {slug:params?.leaseSlug,type:"global"} })}/> </li>
                                    {insuranceInfo?.length > 0 ? <li className='lease-mobile-button'> <Button startIcon={isExport ? <ButtonLoader size={15} /> : <ArrowDownwardIcon />} className='action-btn-start-icon' variant="outlined" size='small' onClick={() => { handleExport(); handleItemClicked('Export Button') }}> Export </Button> </li> : null}
                                </ul>
                            </Grid>
                            <Grid item size={{ md: 12 }} mt='5px'>
                                <CustomTabs
                                    tabsList={['Insurance & Claim', 'Insurance Config']}
                                    onChange={(e, val) => setTabIndex(val)}
                                    value={tabIndex}
                                />
                            </Grid>
                        </Grid>
                    </Paper>
                    {tabIndex === 1 ? <InsuranceClaimCardRU /> : null}
                    {tabIndex === 0 ?
                        <Paper>
                            <Grid container spacing={1} alignItems='flex-end' style={{ display: "flex", justifyContent: "end" }}>
                                <Grid item size={{ md: 12, xs: 12 }}>
                                    <ul className='list-inline insurance-lease-details-right-items lease-details-btn' style={{ padding: '0px' }}>
                                      <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "insurance", operationType: ['C'] }}>
                                            <li><Box className="warning-text" sx={{ display: "flex", alignItems: "center", gap: 0.5 }}> <InfoIcon sx={{ fontSize: 16, color: "#a78701" }} /> It’s required to provide the Insurance Amount before adding a Claim.</Box></li>
                                            <li className='lease-mobile-button'> <Button startIcon={<AddOutlinedIcon />} variant="contained" color="primary" size='small' className='btn-primary action-btn-start-icon' onClick={() => { setInsuranceCRU({ modal: true, data: insuranceObj, mode: 'add' }); handleItemClicked('Add Item Button') }} >Add Insurance</Button></li>
                                        </PermissionWrapper>
                                    </ul>
                                </Grid>
                            </Grid>
                            <div className='lease-detail-table insurance-tab-container'>
                                {skeletonLoader ? <STableLoader count={4} rowCount={isMobile ? 10 : 11} /> : (<>
                                    {insuranceInfo?.length > 0 ? insuranceInfo?.map((item, index) => {
                                        const uploadedFileData = getApiResponse("insurance" || "insurance_claim", item?.slug);

                                        return (
                                            <div style={{ marginBottom: "2px" }}>
                                                <InsuranceList
                                                    slug={slug?.slug}
                                                    setUploadFileStatus={setUploadFileStatus}
                                                    uploadedFileData={uploadedFileData}
                                                    uploadFileProgressData={uploadFileProgressData}
                                                    viewFileStatus={(uploadedFileData) => setUploadFileStatus({ modal: true, data: uploadedFileData, mode: 'view' })}
                                                    item={item}
                                                    index={index}
                                                    key={index}
                                                    onViewFn={() => setInsuranceCRU({ modal: true, data: item, mode: 'view' })}
                                                    viewRevisonHistory={() => setRevisionHistory({ modal: true, data: item, mode: 'view' })}
                                                    onAddVariability={() => setVariabilityCRU({ modal: true, data: item, mode: 'view' })}
                                                    onEditFn={() => setInsuranceCRU({ modal: true, data: item, mode: 'edit' })}
                                                    onDeleteFn={() => setDeleteInsurance({ modal: true, data: item })}
                                                    onOpenAttachments={() => setAttachments({ modal: true, data: item })}
                                                    getResponseBack={() => getInsuranceClaimList('pageloader')}
                                                    onDeletAttachment={() => onDeteAttchments}
                                                />
                                            </div>
                                        )
                                    }
                                    ) : <Paper square><Box sx={{ textAlign: "center", color: "var(--primary-color)", fontSize: "13px", fontWeight: "500", backgroundColor: "#e6ebfb", padding: 1, }}>No Record Found</Box></Paper>
                                    }
                                </>)}
                            </div>
                        </Paper> : null}
                </div>
            </Paper>
            {insuranceCRU?.modal ?
                <InsuranceCRU
                    fileUpload={handleUpload}
                    modeType={insuranceCRU?.mode}
                    insuranceCRU={insuranceCRU}
                    usedInsuranceTypeIds={(insuranceInfo?.list || [])
                        .map((item) => item?.insurance_id ?? item?.insurance_type?.id)
                        .filter((id) => id !== null && id !== undefined)}
                    getResponseBack={() => getInsuranceClaimList('pageloader')}
                    onToggleModal={() => setInsuranceCRU({ modal: false, data: null, mode: '' })}
                    onOpenAttachments={() => setAttachments({ modal: true, data: insuranceCRU?.data, mode: 'view' })}
                />
                : null}
            {deleteInsurance.modal ?
                <DeletePopUp
                    modal={deleteInsurance.modal}
                    title={'Delete Insurance'}
                    onDeleteRecords={() => deleteInsuranceFn()}
                    content={`Are you sure, you want to Delete?`}
                    onToggleModal={() => setDeleteInsurance({ modal: false, data: null })}
                /> : null
            }
            {attachments.modal ?
                <ShowAttachments
                    moduleName="Insurance"
                    url='delete-attachment'
                    permissionKey='insurance'
                    attachmentsData={attachments}
                    getResponseBack={onDeteAttchments}
                    toggleModalFn={() => setAttachments({ modal: false, data: null, mode: '' })}
                    onViewDisabled={insuranceCRU?.mode === 'view' || attachments?.mode === 'view'}
                /> : null
            }
            {
                variabilityCRU.modal &&
                <VariabilityCRU
                    modeType={variabilityCRU?.mode}
                    variabilityCRU={variabilityCRU}
                    onEditVariability={() => setVariabilityCRU({ modal: true, data: variabilityCRU?.data, mode: 'Add' })}
                    getResponseBack={() => getInsuranceClaimList('pageloader')}
                    onToggleModal={() => setVariabilityCRU({ modal: false, data: null, mode: '' })}
                />
            }
            {
                revisionHistory.modal &&
                <RevisionHistory
                    moduleName={"insurance"}
                    revisionHistory={revisionHistory}
                    onToggleModal={() => setRevisionHistory({ modal: false, mode: '', data: null })}
                />
            }
            <FileUploadLayout
                uploadFileStatus={uploadFileStatus}
                open={uploadFileStatus?.modal}
                setUploadFileStatus={setUploadFileStatus}
                uploadFileProgressData={uploadFileProgressData}
                progressRefs={uploadFileProgressData?.progressRefs}
                attachments={uploadFileProgressData?.attachments}
                onDownloadComplete={() => setSlug({})}
            />

            {isLoading ? <PageLoader /> : null}
        </>
    )

}

export default RoleBaseAccess(InsuranceClaim, { application: 'lease_revamp', feature: 'insurance', operationType: ['R'], leaseNav: true });